export var datas = [];

export const urlParams = {
    apiKey:'',
    os:'',
    country:'',
    language:'',
    coins:'',
    cval:'',
  }

  export const dbURL = ''
  export const adv_id = '';
  export const cvalue = [];
/* eslint-disable no-console */
/* eslint-enable no-console */   